import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectStoreModule } from '@app/root-store/shared-store/project-store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FieldStoreModule } from './shared-store/field-store';
import { ProjectTypeStoreModule } from './project-type-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TaskStoreModule } from './task-store';
import { RuleStoreModule } from './rules-store';
import { ReportTypeStoreModule } from './report-type-store';
import { clearState } from './meta/clear-state';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot({}, { metaReducers: [ clearState ]}),
    EffectsModule.forRoot([]),
    ProjectStoreModule,
    FieldStoreModule,
    ProjectTypeStoreModule,
    TaskStoreModule,
    RuleStoreModule,
    ReportTypeStoreModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25,
  }),
  ]
})
export class RootStoreModule { }
